<template>
  <div class="relative inline-block">
    <baseButton @click="toggle">
      <template #iconLeft>
        <chevronUp v-if="!isOpen" fill="white" width="15px" />
        <chevronDown v-if="isOpen" fill="white" width="15px" />
      </template>
    </baseButton>
    <div
      v-if="isOpen"
      @click="close"
      @mouseenter="open"
      @mouseleave="close"
      class="absolute z-50 right-0 mt-6 w-56 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5"
    >
      <div class="py-1 z-50">
        <RouterLink
          to="/alterarsenha"
        >
        <a
          href="/alterarsenha"
          class="flex font-blue px-4 py-2 text-sm hover:bg-gray-100"
        >
          <span class="mr-2">Alterar Senha</span>
          <i class="fa-solid fa-key" style="width: 15px;"></i>
        </a>
        </RouterLink>
        <a
          href="#"
          class="flex font-red px-4 py-2 text-sm hover:bg-gray-100"
          @click="logoutUser"
        >
          <span class="mr-2">SAIR</span>
          <arrowrightfrombracket fill="#D83139" width="15px" />
        </a>
      </div>
    </div>
  </div>
</template>

<script setup>
import baseButton from "@/components/app/buttons/Base.vue";
import chevronUp from "@/components/app/icons/chevron-up.vue";
import chevronDown from "@/components/app/icons/chevron-down.vue";
import arrowrightfrombracket from "@/components/app/icons/arrow-right-from-bracket.vue";
import { useLogout } from "@/composables/useLogout";
import { useToggle } from "@/composables/useToggle";
import { RouterLink } from "vue-router";

const { logoutUser } = useLogout();
const { state: isOpen, toggle, close, open } = useToggle();
</script>
